import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));
